module.exports = __webpack_public_path__ + "media/DetailMap.fbf53676.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/minimap/DetailMap.png
// module id = 1052
// module chunks = 0